export const formDefaultValues = {
  dni: '',
  lastname: '',
  firstname: '',
  email: '',
  repiteEmail: '',
  password: '',
  repitePassword: '',
  mobile: '',
  country: '',
  gender: 'female',
  insurances: { _id: '-', name: 'Particular' },
  policyNumbers: [''],
}
